export const claimPageEmailTemplate = (name) => {
  return `
    <div style="width: 100%; min-height:500px; text-align:center;">
      <div style="margin: 50px 0 30px;">
        <img width="100" height="100" src="https://sommly-image-bucket.s3.us-east-2.amazonaws.com/sommly.png" alt="">
      </div>
      <div>
        <h4>Hello ${name}!</h4>
        <p style="width: 750px; margin: 0 auto; text-align:center;">
          Thanks for claiming your page. A member of the Sommly team is working on your request. You’ll be notified within
          two
          business days about the status and next steps.
        </p>
      </div>
      <div style="margin: 20px 0 50px;">
        <p>Contect us: <span style="color: blue; text-decoration: underline">support@sommly.com</span></p>
      </div>
    </div>
  `
}
export const claimPageEmailTemplateForAdmin = (name, wineryName) => {
  return `
    <div style="width: 100%; min-height:500px; text-align:center;">
      <div style="margin: 50px 0 30px;">
        <img width="100" height="100" src="https://sommly-image-bucket.s3.us-east-2.amazonaws.com/sommly.png" alt="">
      </div>
      <div>
        <h4>Hello Team!</h4>
        <p style="width: 750px; margin: 0 auto; text-align:center;">
          We have got a new claim request from ${name} about "${wineryName}" winery.
        </p>
      </div>
    </div>
  `
}
